import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FINCEN_MATCH_BASE_PATH } from '../../../../../../../../../features/watchlist/fincen/match/fincen-match-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/match/_match')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'fincen-match-list',
        label: 'FinCEN',
        to: FINCEN_MATCH_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
